import { useState } from 'react';
import { useSelector } from 'react-redux';
import TableTitle from '../../Shared/Table/widgets/TableTitle';
import TablePageContainer from '../../Shared/Table/widgets/TablePageContainer';
import BotActivityList from './BotActivityList';

const BotActivities = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(' ');

  return (
    <>
      <TablePageContainer>
        <BotActivityList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.botActivities}
            count={totalCount}
            countFiltered={filterStyle}
          />}
        />
      </TablePageContainer>
    </>
  );
};

export default BotActivities;

